module.exports = __webpack_public_path__ + "static/media/credit_limit_amount.32f8f2e4.svg";